exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#interpretationsEdition{padding:15px}.modal-content{margin-top:30%;color:#000;background-color:#fff!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0d510456","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/commons/sideBarViewer/interpretationsSideBar/InterpretationsEdition.vue
// module id = 1056
// module chunks = 0